<template>
  <div>
    <div class="news-container">
      <template v-if="news.length > 0">
        <section class="news-item" v-for="(n, index) in news" :key="index">
          <h5 class="news-article">n.title_en</h5>
          <p class="news-content mb-4">n.text_en</p>
          <a href="#" class="news-more">Дэлгэрэнгүй</a>
        </section>
      </template>
      <p v-else>Харуулах мэдээ одоогоор байхгүй байна.</p>
    </div>
  </div>
</template>

<script>
import api from '../api/stoTrade.js'

export default {
  name: 'news-list',
  data() {
    return {
      news: [],
    };
  },
  async created() {
    await this.fetchNewsList()
  },
  methods: {
    async fetchNewsList() {
      const { data } = await api.getNews()
      this.news = data
    },
  }
}
</script>

<style lang="scss" scoped>
.news {
  &-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 3rem;
    column-gap: 2rem;
    color: var(--text-primary-color);
  }
  &-item {
    padding: 2rem;
    background: var(--sidebar-background);
    border-radius: 0.5rem;
    transition: all .2s ease-in-out;
    &:hover {
      transform: scale(1.04);
    }
  }
  &-article {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    font-size: 16px;
    font-weight: 600;
    padding-top: 15px;
  }
  &-content {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

    font-size: 16px;
    line-height: 1.5;
  }
  &-more {
    color: rgb(var(--rgb-primary-color));
  }
}

@media (max-width: 768px) {
  .news {
    &-container {
      grid-template-columns: 1fr;
    }
  }
}
</style>
